import React, { type FunctionComponent } from 'react';
import { Route, Routes as MyRoutes, Navigate } from 'react-router-dom';
import { General } from '../screens/General';
import { FileUpload } from '../screens/Fileupload';
import { Submit } from '../screens/Submit';
import { Introduction } from '../screens/Introduction';

export const Routes: FunctionComponent = () => {
    return (
        <MyRoutes>
            <Route path="/" element={<Introduction />} />
            <Route path="/general" element={<General />} />
            <Route path="/fileupload" element={<FileUpload />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="*" element={<Navigate to="/" />} />
        </MyRoutes>
    );
};
